<template lang="pug">
  .row
    .col-lg-12
      table.table.table-striped(v-if="client_list.length > 0 && loaded === true")
        thead
          tr.products-preview
            td.td-05 Id
            td.td-15 Email
            td.td-15 Name
            td.td-05 In&nbsp;bound
            td.td-05 In&nbsp;stock
            td.td-05 In&nbsp;process
            td.td-05 Ready&nbsp;for shipment
            td.td-05 Processing
              br
              | unprinted&nbsp;|&nbsp;ready
            td.td-05 Shipped
              br
              | fba&nbsp;|&nbsp;fbm
            td.td-05 Ready&nbsp;for utilize
            td.td-05 Utilized
            td.td-05(v-if="is_storage && user_role === 'admin'") Summary volume
            td.td-05(v-if="is_storage && user_role === 'admin'") Summary cost
            td.td-05
        tbody
          tr(v-for='(client, i) in client_list')
            td {{client.id}}
            td {{client.email}}
            td {{client.name}}
            td {{client.inbound}}
            td {{client.instock}}
              span.badge.badge-warning.ml-1(v-if="is_storage && client.has_empty_dim") !
            td {{client.inprocess}}
            td {{client.ready_for_shipment}}
            td {{client.processing.unprinted}} | {{client.processing.ready}}
            td {{client.shipped.fba}} | {{client.shipped.fbm}}
            td {{client.ready_for_utilize}}
            td {{client.utilized}}
            td(v-if="is_storage && user_role === 'admin'") {{client.volume | ceil(-2) }}&nbsp;ft
              sup 3
            td(v-if="is_storage && user_role === 'admin'") {{client.storage_cost | ceil(-2)}}$
            td
              button.btn.btn-primary(@click.stop='choseClient(client)') Use

      .spinner-border.mt-4(role='status', v-else-if="loaded === false")
        span.sr-only Loading...

      div.mt-4(v-else-if="loaded === null")
        h5.text-muted.font-weight-semibold Data wasn't loaded. Please reload the page.

      div.mt-4(v-else-if="filteredOrders.length === 0 && loaded")
        span List of clients is empty
</template>

<script>
export default {
  computed: {
    client_list() {
      return this.$store.state.users.client_list;
    },
    chosen_client() {
      return this.$store.state.users.chosen_client;
    },
    app_section() {
      return this.$store.getters.get_app_section;
    },
    loaded() {
      return this.$store.state.users.loaded;
    },
    is_storage() {
      return this.$store.getters.is_storage;
    },
    user_role() {
      return this.$store.state.users.role;
    },
  },
  created() {
    this.$store.dispatch('lc_set_loaded', false);
    this.$store.dispatch('loadClientList');
  },
  methods: {
    choseClient(client) {
      this.$store.dispatch('setClient', client)
        .then(() => {
          this.$router.push({name: `${this.app_section}-in-bound`});
        })
        .then(() => this.$store.dispatch('subscribe_badges', this.chosen_client));
    },
  },
};
</script>
